const onboardingQueries = {
  onboardingFileAuthorization: () => ['onboarding/file-autorization'],
}

export default onboardingQueries
